import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2220_holiday_calendar_details: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Holiday Calendar",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            // Header: action buttons aligned right
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 12,
                    padding: "16px 24px",
                    marginBottom: "24px",
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                } as any,
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        name: "add_holiday_btn",
                        Label: "Add Holiday",
                        onPressAction: "navigate_2224",
                        style: {
                            backgroundColor: "rgb(10, 168, 76)",
                            color: "#ffffff",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            fontWeight: 600,
                        },
                    } as any,
                    {
                        componentType: ComponentType.BUTTON,
                        name: "publish_btn",
                        Label: "Publish Calendar",
                        onPressAction: "publish_calendar_start",
                        style: {
                            backgroundColor: "#6366F1",
                            color: "#FFFFFF",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            fontWeight: 600,
                        },
                    } as any,
                ],
            },

            // Holidays List
            {
                componentType: LayoutTypes.GROUP,
                Label: "Holidays",
                style: {
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "20px",
                    marginBottom: "24px",
                } as any,
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        name: "holiday_list_table",
                        Name: "holiday_list",
                        DisplayName: "Holidays",
                        titleValue: "holiday_name",
                        apiname: "holiday_list",
                        TableName: "holiday_list",
                        Filter: "holiday_list.soft_delete=0",
                        Parent_Field: "id",
                        HasLockedColumn: false,
                        Form: {
                            Name: "holiday_list",
                            TableName: "holiday_list",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Holiday Date",
                                    BindValue: "holiday_date",
                                    Json_Attribute: "holiday_date",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Holiday Name",
                                    BindValue: "holiday_name",
                                    Json_Attribute: "holiday_name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Type",
                                    BindValue: "holiday_type",
                                    Json_Attribute: "holiday_type",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Applicable To",
                                    BindValue: "applicable_to",
                                    Json_Attribute: "applicable_to",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Paid",
                                    BindValue: "paid_holiday",
                                    Json_Attribute: "paid_holiday",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                    valueFormat: "boolean",
                                } as any,
                            ],
                        },
                        SummeryActions: [
                            {
                                ActionType: "Edit",
                                Label: "Edit",
                                Action: {
                                    Action: "edit_holiday",
                                    Module: "holiday_list",
                                },
                                ScreenId: "2224",
                                visibility: [1],
                            },
                            {
                                ActionType: "Delete",
                                Label: "Delete",
                                Action: {
                                    Action: "Delete",
                                    Module: "holiday_list",
                                },
                                visibility: [1],
                            },
                        ],
                    } as any,
                ],
            },

            // Weekly Off Settings
            {
                componentType: LayoutTypes.GROUP,
                Label: "Weekly Off Settings",
                style: {
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "24px",
                } as any,
                childComponents: [
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            direction: FlexDirection.ROW,
                            justifyContent: "flex-end",
                            marginBottom: "16px",
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.BUTTON,
                                name: "add_weekly_off_btn",
                                Label: "Add Weekly Off",
                                onPressAction: "navigate_2225",
                                style: {
                                    backgroundColor: "rgb(10, 168, 76)",
                                    color: "#ffffff",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    fontWeight: 600,
                                },
                            } as any,
                        ],
                    },
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        name: "weekly_off_table",
                        Name: "holiday_weekly_off",
                        DisplayName: "Weekly Off Settings",
                        titleValue: "day_of_week",
                        apiname: "holiday_weekly_off",
                        TableName: "holiday_weekly_off",
                        Filter: "holiday_weekly_off.soft_delete=0",
                        Parent_Field: "id",
                        HasLockedColumn: false,
                        Form: {
                            Name: "holiday_weekly_off",
                            TableName: "holiday_weekly_off",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Day",
                                    BindValue: "day_of_week",
                                    Json_Attribute: "day_of_week",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Paid Weekly Off",
                                    BindValue: "paid_weekly_off",
                                    Json_Attribute: "paid_weekly_off",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                    valueFormat: "boolean",
                                } as any,
                                {
                                    IncludeLabel: true,
                                    Label: "Notes",
                                    BindValue: "notes",
                                    Json_Attribute: "notes",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                            ],
                        },
                        SummeryActions: [
                            {
                                ActionType: "Edit",
                                Label: "Edit",
                                Action: {
                                    Action: "edit_weekly_off",
                                    Module: "holiday_weekly_off",
                                },
                                ScreenId: "2225",
                                visibility: [1],
                            },
                            {
                                ActionType: "Delete",
                                Label: "Delete",
                                Action: {
                                    Action: "Delete",
                                    Module: "holiday_weekly_off",
                                },
                                visibility: [1],
                            },
                        ],
                    } as any,
                ],
            },
        ],
    },
];
